import type { RouteRecordRaw } from 'vue-router'

export const portalRoutes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('@/layouts/PortalLayout.vue'),
    children: [
      { path: '', redirect: '/dashboard' },
      {
        path: 'dashboard',
        name: 'portal-dashboard',
        component: () => import('@/pages/portal/PortalDashboard.vue')
      },
      {
        path: 'documents',
        name: 'portal-documents',
        component: () => import('@/pages/portal/PortalDocuments.vue')
      },
      {
        path: 'documents/:id',
        name: 'portal-document-detail',
        component: () => import('@/pages/portal/PortalDocumentDetail.vue')
      },
      {
        path: 'invoices',
        name: 'portal-invoices',
        component: () => import('@/pages/portal/PortalInvoices.vue')
      },
      {
        path: 'forms',
        name: 'portal-forms',
        component: () => import('@/pages/portal/PortalForms.vue')
      },
      {
        path: 'forms/:id',
        name: 'portal-form-fill',
        component: () => import('@/pages/portal/PortalFormFill.vue')
      },
      {
        path: 'appointments',
        name: 'portal-appointments',
        component: () => import('@/pages/portal/PortalAppointments.vue')
      },
      {
        path: 'appointments/:id',
        name: 'portal-appointment-detail',
        component: () => import('@/pages/portal/PortalAppointmentDetail.vue')
      },
    ],
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'portal-login',
    component: () => import('@/pages/portal/PortalLogin.vue')
  },
  {
    path: '/auth/callback',
    name: 'portal-auth-callback',
    component: () => import('@/pages/portal/PortalAuthCallback.vue')
  },
]
